import React from 'react';
import EntityModal from '../common/EntityModal';
import DealForm from './DealForm';

const DealModal = ({ isOpen, onClose, deal = null, onSubmit, loading = false }) => (
  <EntityModal
    isOpen={isOpen}
    onClose={onClose}
    entity={deal}
    entityName="Opportunity"
    entityPropName="deal"
    FormComponent={DealForm}
    onSubmit={onSubmit}
    loading={loading}
    size="lg"
  />
);

export default DealModal;
